import config from "./configuration";

/* Client for /api/accounts-flow (receipts/payments with approval, ledger statement). */

export class FlowApiError extends Error {
  constructor(message, { errors = [], status } = {}) {
    super(message);
    this.name = "FlowApiError";
    this.errors = errors;
    this.status = status;
    this.fieldErrors = {};
    errors.forEach((item) => {
      if (item && item.field && !this.fieldErrors[item.field]) this.fieldErrors[item.field] = item.message;
    });
  }
}

function token() {
  try {
    return JSON.parse(localStorage.getItem("userData") || "{}").token || "";
  } catch (err) {
    return "";
  }
}

function queryString(query) {
  const params = new URLSearchParams();
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params.set(key, value);
  });
  const text = params.toString();
  return text ? `?${text}` : "";
}

async function request(path, { method = "GET", body, query } = {}) {
  let response;
  try {
    response = await fetch(`${config.BASE_URL}api/accounts-flow${path}${queryString(query)}`, {
      method,
      headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${token()}` },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (err) {
    throw new FlowApiError("Could not reach the server. Check that the API is running.");
  }
  if (response.status === 401) {
    localStorage.setItem("token", "");
    localStorage.setItem("userData", "");
    window.location = "/";
    return null;
  }
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || Number(payload.status) >= 400) {
    throw new FlowApiError(payload.message || "Request failed", { errors: payload.errors || [], status: Number(payload.status) || response.status });
  }
  return payload;
}

const accountsFlowApi = {
  meta: () => request("/meta"),
  materials: () => request("/materials"),
  companies: () => request("/companies"),
  openInvoices: (ledgerId) => request("/receipts/open-invoices", { query: { ledgerId } }),
  saveEntry: (body) => request("/entries", { method: "POST", body }),
  postVoucher: (body) => request("/vouchers", { method: "POST", body }),
  entries: (query) => request("/entries", { query }),
  entry: (id) => request(`/entries/${id}`),
  approve: (id, note) => request(`/entries/${id}/approve`, { method: "POST", body: { reason: note || "" } }),
  reject: (id, reason) => request(`/entries/${id}/reject`, { method: "POST", body: { reason } }),
  docStatus: (type, refs) => request("/doc-status", { query: { type, refs: (refs || []).filter(Boolean).join(",") } }),
  sourceStatus: (type, refs) => request("/entries/source-status", { query: { type, refs: (refs || []).filter(Boolean).join(",") } }),
  orderTrail: (orderNo) => request(`/orders/${encodeURIComponent(orderNo)}/trail`),
  approveOrderCredit: (orderNo, note) => request(`/orders/${encodeURIComponent(orderNo)}/credit-approve`, { method: "POST", body: { note } }),
  rejectOrderCredit: (orderNo, reason) => request(`/orders/${encodeURIComponent(orderNo)}/credit-reject`, { method: "POST", body: { reason } }),
  statement: (query) => request("/reports/ledger-statement", { query }),
  customerOpening: (code) => request(`/customers/${encodeURIComponent(code)}/opening`),
  cancelSales: (id, reason) => request(`/sales/${id}/cancel`, { method: "POST", body: { reason } }),
};

export default accountsFlowApi;
